import { render, staticRenderFns } from "./TheQuiz2.vue?vue&type=template&id=20315786&scoped=true&"
import script from "./TheQuiz2.vue?vue&type=script&lang=js&"
export * from "./TheQuiz2.vue?vue&type=script&lang=js&"
import style0 from "./TheQuiz2.vue?vue&type=style&index=0&id=20315786&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20315786",
  null
  
)

export default component.exports